<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ba5"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('driveinform_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('driveinform_mergePush_button') && switchTax != 2"
          @click="funMergePush"
        >
          汇总推送
        </el-button>
        <el-button
          v-if="getLimit('driveinform_batchSendTax_button')"
          @click="getSelectEvent()"
        >
          批量同步
        </el-button>
        <el-button
          v-if="getLimit('driveinform_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      class="mytable-style"
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" />
      <vxe-table-column>
        <vxe-table-column field="name" title="姓名" min-width="130" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="phone" title="手机" min-width="130" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入手机"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="identificationNumber"
          title="身份证号"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.identificationNumber"
            placeholder="请输入身份证号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="balance"
          title="余额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.balanceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.balanceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseNumber"
          title="车牌号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicenseNumber"
            placeholder="车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="注册时间"
          min-width="360"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          v-if="ctmsShow"
          field="vehicleNetStatus"
          :formatter="formatterVehicleNetStatus"
          title="车辆入网"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleNetStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in vehicleNetStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isSendTaxExt"
          title="上报状态"
          :formatter="formatterSendStatus"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isSendTaxExt"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in sendTaxOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="150" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              getLimit('driveinform_sendTax_button') &&
                scope.row.isSendTaxExt === 0
            "
            class="item"
            effect="dark"
            content="同步税务信息"
            placement="top"
          >
            <vxe-button type="text" @click="funInfo(scope.row.code)">
              <i class="el-icon-sort" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('driveinform_applyTax_button') && switchTax != 2"
            class="item"
            effect="dark"
            content="税务申报"
            placement="top"
          >
            <vxe-button type="text" @click="otherTaxApply(scope.row.code)">
              <i class="el-icon-upload2" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('driveinform_apply_button') && switchTax != 2"
            class="item"
            effect="dark"
            content="个人税务上报"
            placement="top"
          >
            <vxe-button type="text" @click="funApply(scope.row.partyCode)">
              <i class="el-icon-upload2" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import request from "@/utils/request";
import { getRole } from "@/utils/getRole";
import {
  taxDriverInfo,
  taxApply,
  mergePush,
  otherTaxApply,
  taxSwitch
} from "@/api/Taxation";
export default {
  name: "Driveinform",
  data() {
    return {
      isCtms: true, //默认显示 同城系统时隐藏
      sendTaxOptions: [
        {
          value: "0",
          label: "未上报"
        },
        {
          value: "1",
          label: "已上报"
        },
        {
          value: "2",
          label: "上报失败"
        }
      ],

      switchTax: "",
      loading: false,
      tableData: [],
      gmtCreatedRange: "",
      modelAddFlag: false,
      modelEditFlag: false,
      modelDetailFlag: false,
      modelImportFlag: false,
      ctmsShow: true,
      exportObj: {
        exportUrl: "/ntocc-basic-api/driver/exportTaxDriver", //导出接口
        name: "实际承运人信息"
      },
      listQuery: {
        gmtCreatedRange: "",
        authStatus: "3",
        authStatusExt: "3",
        branchCodeExt: this.$store.state.user.party.branchCode,
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      sumObject: {
        balance: 0
      },
      //车辆入网
      vehicleNetStatusOptions: [
        {
          label: "未入网",
          value: 0
        },
        {
          label: "已入网",
          value: 1
        }
      ]
    };
  },
  created() {
    this.taxSwitch();
    this.findList();
    this.isCtmsShow = getRole(); //获取登录用户登录的是否是同城系统
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    this.platformDid = dataBranch.platformDid;
    this.openMaYiBlockChain = dataBranch.partyGroupConfigCacheMap
      .MaYiBlockChainConfig_useMaYiBlockChain
      ? dataBranch.partyGroupConfigCacheMap
          .MaYiBlockChainConfig_useMaYiBlockChain.configValue == 1
        ? true
        : false
      : false;
  },
  methods: {
    getSelectEvent() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择实际承运人信息", type: "warning" });
      } else {
        const codes = selectRecords.map(item => item.code).join(",");
        this.$confirm("确认批量同步实际承运人信息吗？").then(_ => {
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/driver/taxDriverInfoList",
            method: "put",
            params: { codes: codes }
          })
            .then(response => {
              this.$message.success(response.msg);
              rLoading.close();
            })
            .finally(() => {
              this.$refs.xTable.clearCheckboxRow();
              this.findList();
            });
        });
      }
    },
    taxSwitch() {
      taxSwitch().then(response => {
        this.switchTax = response.data;
      });
    },
    formatterSendStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "未上报";
        case 1:
          return "已上报";
        case 2:
          return "上报失败";
        default:
          break;
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-basic-api/driver/taxList",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 实际承运人信息推送
    async funInfo(code) {
      const rLoading = this.openLoading();
      let res = await taxDriverInfo({ code });
      rLoading.close();
      this.$message.success(res.msg);
      this.findList();
    },
    // 实际承运人个人税务上报
    async funApply(code) {
      const rLoading = this.openLoading();
      let res = await taxApply(code);
      rLoading.close();
      this.$message.success(res.msg);
    },
    // 实际承运人税务上报
    async otherTaxApply(code) {
      const rLoading = this.openLoading();
      let res = await otherTaxApply({ code });
      rLoading.close();
      this.$message.success(res.msg);
    },
    // 实际承运人个人所得税汇总推送
    async funMergePush() {
      const rLoading = this.openLoading();
      let res = await mergePush();
      rLoading.close();
      this.$refs.xTable.clearCheckboxRow();
      this.$message.success(res.msg);
      this.findList();
    },
    // 翻译审核状态
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译车辆入网
    formatterVehicleNetStatus({ cellValue }) {
      const item = this.vehicleNetStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 隐藏弹框
    hideModel() {
      this.modelImportFlag = false;
      this.findList();
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    }
  }
};
</script>
<style scoped>
::v-deep .el-range-separator {
  box-sizing: content-box;
}
</style>
